import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseCrudService } from './base-crud.service';
import { User } from '../../shared/models';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseCrudService<User> {
  protected readonly endpoint = 'User';

  searchByEmail(email: string): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}/SearchByEmail`, { params: { email } });
  }
}
